$(document).ready(function () {
      setTimeout(function() {
            $('.oke-sr-total-text').text(function(index, text) {
                return text.replace(/ Reviews?/g,'');
            });
    }, 500);
   setTimeout(function() {
    var labelText = $(".rc-radio__label").first().text(); 
    
    // Extract the price (assuming it's the second word)
    var price = labelText.split(" ").pop();
    // Replace the price with a new span element containing the price
    var newHTML = labelText.replace(price, ' ');
    
    // Update the HTML of the first element with the modified HTML
    $(".rc-radio__label").first().html(newHTML); 
       $(".rc-radio__label").first().after("<span class='bundlePrice'>"+ price +"</span>");
     }, 4000);
});
